<template>
  <div>
    
    <template >
      <v-card >

    


<v-carousel 
  :height="$vuetify.breakpoint.xs ? 220 : 300"
  cycle 
  hide-delimiters
>
  <v-carousel-item
    v-for="(vendedor,i) in vendedores"
    :key="i"
  >

    <!-- fondo -->
    <div
      :style="{
        background:'linear-gradient(135deg,' + vendedor.principal.color + ', #ffffff)',
        height: $vuetify.breakpoint.xs ? 'auto' : '300px',
        minHeight: $vuetify.breakpoint.xs ? '220px' : '300px',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center',
        padding: $vuetify.breakpoint.xs ? '15px' : '0 60px'
      }"
    >

      <!-- titulo arriba centrado -->
      <div class="text-center mb-2"
        :style="{
          fontSize: $vuetify.breakpoint.xs ? '16px' : '20px',
          fontWeight:700,
          color:'#222'
        }"
      >
      
        Productos y Servicios de: {{ vendedor.nombre }} {{ vendedor.apellido }}
      </div>

      <!-- fila: avatar+boton | info -->
      <div style="display:flex;align-items:center;width:100%;">

        <!-- avatar + boton -->
        <div style="display:flex;flex-direction:column;align-items:center;">
          <v-avatar 
            :size="$vuetify.breakpoint.xs ? 80 : 150"
            class="elevation-5"
          >
            <div style="overflow:hidden">

              <img
                :src="server_url + 'api/principal/get_image/' + vendedor.principal.identificador + '/' + vendedor.principal.linkPhoto"
                :style="{
                  height: $vuetify.breakpoint.xs ? '80px' : '150px',
                  transform:'scale(' + ((vendedor.principal.zoom || 50)/50) + ') translate(' + vendedor.principal.fotox + 'px,' + vendedor.principal.fotoy + 'px)',
                  transition:'transform 0.2s'
                }"
              />

            </div>
          </v-avatar>

          <v-btn
            :small="$vuetify.breakpoint.xs"
            class="mt-2 elevation-2"
            :style="{
              background: darkenColor(vendedor.principal.color,20),
              color:'#fff',
              textTransform:'none'
            }"
            @click="perfilOpen(vendedor.identificador)"
          >
            Ver perfil
            <v-icon right small>mdi-account</v-icon>
          </v-btn>
        </div>

        <!-- info -->
        <div :class="$vuetify.breakpoint.xs ? 'ml-3' : 'ml-10'" style="flex:1;">

          <!-- descripcion -->
          <div
            :style="{
              fontSize: $vuetify.breakpoint.xs ? '12px' : '15px',
              color:'#444',
              maxWidth: $vuetify.breakpoint.xs ? '200px' : '520px',
              marginTop:'6px'
            }"
          >
            {{ vendedor.principal.descripcion }}
          </div>




        <!-- TITULO -->
        <v-row>
          <v-col cols="12" :class="$vuetify.breakpoint.xs ? 'pt-4' : 'pt-10'">
            <div
          class="mt-1"
              :style="{
                fontSize: $vuetify.breakpoint.xs ? '13px' : '16px',
                fontWeight:600,
                color:'#333',
                
              }"
            >
              Categorías
            </div>
          </v-col>
        </v-row>

        <!-- categorias -->
        <v-row>

          <v-col
            cols="12"
            :style="{
              display:'flex',
              flexWrap:'wrap',
              gap: $vuetify.breakpoint.xs ? '10px' : '20px',
              alignItems:'center',
              fontSize: $vuetify.breakpoint.xs ? '12px' : '15px'
            }"
          >

            <div
              v-for="cat in categoriasPorVendedor(vendedor.identificador)"
              :key="cat.id"
              style="display:flex;align-items:center;gap:6px"
            >

              <v-icon :small="$vuetify.breakpoint.xs">
                {{ cat.categoria_icon }}
              </v-icon>

              {{ cat.descripcion }}

            </div>

          </v-col>

        </v-row>

      </div> <!-- cierre info -->

    </div> <!-- cierre flex-row -->

    </div>

  </v-carousel-item>

</v-carousel>



<!-- {{ vendedores }} -->



        <!-- <v-system-bar>para colocar rutas etc si se desea</v-system-bar> -->
        <!-- DATOS DEL VENDEDOR -->
        <!--  <template>
          <div class="text-center">
            <v-menu v-model="principalMenu" :close-on-content-click="false" :nudge-width="300" offset-x>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" class="pa-0 ma-0">
                  <v-avatar size="40">
                    <img
                      :src="server_url + 'api/principal/get_image/' + principal.identificador + '/' + principal.linkPhoto"
                      alt="Foto del vendedor">
                  </v-avatar> Datos del Vendedor
                </v-btn>
              </template>


<v-card class="pa-4" outlined>

  <h3 class="mb-2 text-center">Datos del Vendedor</h3>

  <v-row>
    <v-col cols="12" sm="12" md="3" lg="3" class="d-flex justify-center">
      <v-avatar size="20vh" class="ma-0">
        <a data-fancybox data-caption="Single image"
          :href="server_url + 'api/principal/get_image/' + principal.identificador + '/' + principal.linkPhoto">
          <img :src="server_url + 'api/principal/get_image/' + principal.identificador + '/' + principal.linkPhoto"
            :style="{
                            height: '20vh',
                            transform: 'scale(' + this.principal.zoom / 50 + ') translate(' + principal.fotox + 'px,' + principal.fotoy + 'px)',
                            transition: 'transform 0.2s'
                          }" />
        </a>
      </v-avatar>
    </v-col>

    <v-col cols="12" sm="7" lg="9" align-self="center">
      <v-card-title :style="{
                      fontSize: '20px',   /* Tamaño */
                      fontWeight: '500',   /* Peso */
                      letterSpacing: '-.015625em', /* Espaciado */
                      /* marginBottom: active ? '-1rem' : '0', /* Margen dinámico */
                      color: principal.color
                    }" class="mt-0 pt-0  mb-0">{{ principal.nombre }} {{ principal.apellido }}</v-card-title>

      <v-card-title :style="{
                      fontSize: '15px',   /* Tamaño */
                      fontWeight: '500',   /* Peso */
                      letterSpacing: '-.015625em', /* Espaciado */
                      /*   marginBottom: active ? '-1rem' : '0', /* Margen dinámico    grey--text en la parte de class de abajo*/
                      color: principal.color
                    }" class="mt-0 pt-0   mb-1">{{ principal.descripcion }}</v-card-title>

    </v-col>
  </v-row>




  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn color="primary" text @click="principalMenu = false">
      Cerrar
    </v-btn>
  </v-card-actions>

</v-card>
</v-menu>
</div>
</template>
-->

        <!-- FIN DATOS DEL VENDEDOR -->


        <!--     <v-toolbar flat>
          <v-toolbar-title>Productos {{buscador}} </v-toolbar-title>

          <p>Buscando: {{ buscador }}</p>

        </v-toolbar> -->

        <!--
        <template>
  <div class="text-center">
    <v-menu
      v-model="categoriaMenu"
      :close-on-content-click="false"
      :nudge-width="300"
      offset-x
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="indigo"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Filtrar por Categoría
        </v-btn>
      </template>

      <v-card class="pa-4" outlined>

        
        <h3 class="mb-2 text-center">Filtrar por Categoría</h3>

        <v-radio-group v-model="categoriaSeleccionada" column>
          <v-radio
            v-for="(cat, i) in categorias"
            :key="i"
            :label="cat.descripcion"
            :value="cat.descripcion"
          ></v-radio>
        </v-radio-group>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="categoriaMenu = false">
            Cerrar
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-menu>
  </div>
</template>  -->




        <v-card-text class="">
          <!-- <v-sheet class="mx-auto"> -->
          <!-- INICIO CARD -->
          <template>

            <!-- {{ this.vendedorSeleccionado }} -->


            <!-- <v-banner single-line :sticky="sticky" color="white"> -->


            <!-- FILTRO DE CATEGORÍAS 
      <v-row justify="center" class="mb-4">
        <v-col cols="12" md="10">
          <v-card class="pa-3" outlined>
            <h3 class="mb-2">Filtrar por Categoría</h3>
            <v-radio-group v-model="categoriaSeleccionada" row>
              <v-radio
                v-for="(cat, i) in categorias"
                :key="i"
                :label="cat.descripcion"
                :value="cat.descripcion"
              ></v-radio>
            </v-radio-group>
          </v-card>
        </v-col>
      </v-row>
    -->


            <!-- <v-row>

            <v-col cols="12" sm="12" md="8" lg="8">
              <v-text-field v-model="buscador" placeholder="Ejemplo:Tablero de Ajedrez, Arduino, Crema, Locion"
                outlined>
                <template v-slot:label>
                  <v-icon style="vertical-align: middle">
                    mdi-magnify
                  </v-icon>
                  Busqueda por descripcion de productos
                </template>


  </v-text-field>


  </v-col>



  </v-row> -->

            <!-- </v-banner> -->
            <v-row style="position: relative;" class="product-grid">
              <v-col cols="12" sm="12" md="4" lg="4" v-for="producto in productosFiltrados" :key="producto.codigo">
                <v-card class="mx-auto" max-width="420"><v-img class="white--text align-end" contain height="200px"
                    style="cursor: pointer;"
                    :src="server_url + 'api/productos/get_img_unico_producto/' + producto.id + '/' + producto.link_photo"
                    @click="abrirDetalle(producto)"></v-img>

                  <v-card-title class="pa-4 pb-0"
                    style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{
                      producto.descripcion }}</v-card-title>


                  <v-card-subtitle class="pa-4 pt-4"
                    style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                    {{ producto.sub1 }}
                  </v-card-subtitle>


                  <v-card-title class="pa-4 pt-0"
                    style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: #8B0000;">
                    Gs.{{ formatearPrecio(producto.pvu) }}
                  </v-card-title>

                  <!-- los de stock agotado, ni mostrar en el listado , o ser solo un puente para su inactivacion-->
                  <v-card-text class="pa-4 pt-0">

                    <!-- Si no hay stock -->
                    <div v-if="producto.cantidad_total <= 0" class="red--text d-flex align-center">
                      <v-icon small class="mr-1 red--text">mdi-cancel</v-icon>
                      Stock Agotado
                    </div>

                    <!-- Si hay stock -->
                    <div v-else class="green--text d-flex align-center">
                      <v-icon small class="mr-1 green--text">mdi-check-circle-outline</v-icon>
                      Disponible
                    </div>

                  </v-card-text>


                  <v-card-actions class="pa-4 pt-0">


                    <v-row>
                      <v-col cols="12">




                        <v-btn class="pa-2 pt-0" outlined text color="blue darken-4" @click="openConsultar(producto)">
                          <v-icon left>
                            mdi-whatsapp
                          </v-icon>

                          WhatsApp

                        </v-btn>

                      </v-col>

                      <v-col cols="10">

                        <v-btn class="pa-2 pt-0" outlined text color="blue darken-4" @click="perfilOpen(producto.vendedor.identificador)">
                           <v-icon left>mdi-account</v-icon>
                            Ir a Perfil del Vendedor
                         
                        </v-btn>

                      </v-col>

                      <v-col cols="12">
                        <v-btn class="pa-2 pt-0" outlined text color="orange darken-2" @click="abrirDetalle(producto)">
                          <v-icon left>mdi-cart-plus</v-icon>
                          Comprar
                        </v-btn>
                      </v-col>


                        <v-col cols="2">

                            <v-spacer></v-spacer>
                    <v-btn icon @click="toggleExpand(producto.descripcion)">
                      <v-icon>{{ expandedId === producto.descripcion ? 'mdi-chevron-up' : 'mdi-chevron-down'
                      }}</v-icon>
                    </v-btn>
                        </v-col>

                    </v-row>

                    <!-- 
                      <v-btn outlined text color="blue darken-4" class="mr-4 pa-2 pt-0"
                        @click="productoOpen(producto.descripcion)">
                        <v-icon>
                          mdi-cart-plus
                        </v-icon>
                        Add Producto
                      </v-btn> -->


                  



                  </v-card-actions>


                  <v-expand-transition>
                    <div v-show="expandedId === producto.descripcion">
                      <v-divider></v-divider>



                      <v-card-text>


                        <v-card-subtitle :style="{
                          fontSize: '15px',   /* Tamaño */
                          fontWeight: '500',   /* Peso */
                          letterSpacing: '-.015625em', /* Espaciado */
                          /*   marginBottom: active ? '-1rem' : '0', /* Margen dinámico    grey--text en la parte de class de abajo*/
                          color: '#78909C'
                        }">
                          Información Detallada
                        </v-card-subtitle>

                        <div class="d-flex justify-start">{{ producto.info }}</div>





                      </v-card-text>


                    </div>
                  </v-expand-transition>

                </v-card>

              </v-col>




              <v-col cols="12" class="text-center" v-if="hasMoreProductos">
                <v-btn outlined color="blue darken-4" @click="cargarMasProductos">
                  Ver más
                </v-btn>
              </v-col>

              <div v-if="loading" class="loading-overlay">
                <v-progress-circular indeterminate color="grey darken-3" size="64"></v-progress-circular>
              </div>

            </v-row>
          </template>

          <!-- FIN NUEVO CARD  -->

          <DetalleProductoDialog
            v-model="dialogDetalle"
            :producto="productoSeleccionado"
            :serverUrl="server_url"
          />





          <!-- </v-sheet> -->
        </v-card-text>
      </v-card>
    </template>
  </div>
</template>


<script>
import productoService from "@/services/tienda/productoService.js";

import vendedorService from "@/services/tienda/vendedorService.js";

import categoriaService from "@/services/tienda/categoriaService.js";

import principalService from "@/services/principalService.js";

import axios from 'axios';

import { http } from "@/services/config";

import DetalleProductoDialog from "@/components/tienda/menu/DetalleProductoDialog.vue";



export default {
  name: 'homeTiendaAll',

  components: {
    DetalleProductoDialog
  },
  computed: {

  },

  props: {
    buscador: {
      type: String,
      default: "",
    },
    categoriaSeleccionada: {
      type: String,
      default: "todos"
    },
    vendedorSeleccionado: {
      type: [String, Number],
      default: 0
    }
  },


  data: vm => ({

    // este sí es tu valor real editable:
    //vendedorSeleccionado: 'todos',


    vendedorSeleccionadoLocal: 0,
    categoriaSeleccionadaLocal: 'todos',
    categoria: 'todos',

    identificadorConsulta: 'magzoa',
    nombreTienda: 'TecZoa',

    categoriaMenu: false,

    principalMenu: false,

    principal: {

      id: '',
      nombre: '',
      apellido: '',
      descripcion: '',
      linkPhoto: '',
      color: '',
      observacion: '',
      linkVideo: '',
    },

    //categoriaSeleccionada: "todos",
    categorias: [],
           vendedores:[],

    sticky: true,
    loading: false,
    paginaActual: 1,
    ultimaPagina: 1,
    productosPorPagina: 18,
    totalProductos: 0,

    mensaje: {
      snackbar: false,
      text: '',
      color: '',
      timeout: -1,
    },

    server_url: "",
    expandedId: null,
    dialogDetalle: false,
    productoSeleccionado: null,    valid: true,
    // buscador: '',  
    productos: [],
    producto: {
      id: '',
      descripcion: '',
      sub1: '',
      sub2: '',
      sub3: '',
      sub4: '',
      sub5: '',
      link_photo: '',
      cantidad_total: '',
      pvu: '',
      info: '',
      observacion: '',
      zoom: 50,
      //color:'#FFFFFF', //COLOR POR DEFECTO

    },
    rules: {
      required: value => !!value || 'Campo Requerido',
      min: v => v.length >= 5 || 'Minimo 5 caracteres',
      emailMatch: () => (`The email and password you entered don't match`),
    },
    messages: undefined,



    textRules: [
      (v) => !!v || "Campo es requerido",
      (v) => (v && v.length >= 3) || "Debe contener al menos 3 caracteres",
    ],







  }),
  created() {

  }
  , async mounted() {



    this.listarCategoriasPublico();


   

    this.server_url = http.defaults.baseURL;

    console.log("Ingreseeee");

    this.listarOpcions();

    //  this.listarCategoriasPublico();


    // this.getUserPorIdentificador(this.$route.params.identificador);


    const id = this.$route.params.identificador;

    let valor = 'all';

    switch (id) {//  VERIFICAR ESTE METODO , POR QUE EN MENU PANTALLA STORE YA ESTA ACTUALIZADO
      case 'all':
        valor = 'all';

        this.vendedorSeleccionadoLocal = valor;

        this.listarProductos(this.vendedorSeleccionadoLocal);  // PROBABLE YA SE HACIA DOBLE CONSULTA AL INICIAR

  await   this.listarVendedores(this.vendedorSeleccionadoLocal);

        break;

      /*case 'magzoa':
        valor='magzoa';
        console.log('INGRESE EN TECZOA'+valor);
         break;
      case 'lizmar':
        valor='lizmar';

        console.log('INGRESE EN LIZMAR'+valor);
        break;*/

      //default:
      //  valor = 0;
      //   break;
    }




  },

  methods: {


    categoriasPorVendedor(identificador) {

    return this.categorias.filter(
      c => c.vendedor?.identificador === identificador
    );

  },

    abrirDetalle(producto) {
      this.productoSeleccionado = producto;
      this.dialogDetalle = true;
    },
     listarCategoriasPublico() {
   //   console.log('se invocooooo');
      categoriaService
        .listarCategoriasTodosPublico()
        .then((resposta) => {
     //     console.log(resposta.data);
          this.categorias = resposta.data;
        }).finally(() => {
        //  this.loading = false;
        });

    },

     darkenColor(hex,percent){

    let r = parseInt(hex.substring(1,3),16)
    let g = parseInt(hex.substring(3,5),16)
    let b = parseInt(hex.substring(5,7),16)

    r = parseInt(r * (100-percent) / 100)
    g = parseInt(g * (100-percent) / 100)
    b = parseInt(b * (100-percent) / 100)

    return `rgb(${r},${g},${b})`
  },
    

    async listarVendedores(identificador) {
  try {
    const res = await vendedorService.listarVendedores();

    let vendedores = res.data.data.slice(1);

    // Si no es "all", filtrar
    if (identificador !== "all") {
      vendedores = vendedores.filter(
        v => v.identificador === identificador
      );
    }

    this.vendedores = vendedores;

    //this.validarRuta();

  } catch (error) {
    console.error(error);
  } finally {
    this.loading = false;
  }
},


    perfilOpen(identificador) {


      //this.$router.push(`/perfil/`+identificador);


      const url = this.$router.resolve({ path: `/perfil/${identificador}` }).href;
      window.open(url, '_blank');


    },

    listarOpcions() {

      principalService
        .listarPrincipalsOpcionPorIdentificador(this.identificadorConsulta)
        .then((res) => {
          console.log(res.data);
          console.log(res.data.principal);

          // this.opcions = res.data.principal.opciones;
          this.principal = res.data.principal;
        }).finally(() => {
          this.loading = false;
        })

    },

    /*listarCategoriasPublico() {
      this.loading = true;


      categoriaService
        .listarCategoriasPorVendedor(this.vendedorSeleccionadoLocal)
        .then((resposta) => {
          console.log(resposta.data);
          this.categorias = resposta.data.data;
        }).finally(() => {
          this.loading = false;
        });

    },*/




    openConsultar(producto) {
      const whatsappUrl = this.generarUrlWhatsapp(producto);
      window.open(whatsappUrl, '_blank'); // abre en nueva pestaña
    },

    generarUrlWhatsapp(producto) {
      const numero = producto.vendedor.celular; // número real de WhatsApp en formato internacional
      const imagenUrl = `${this.server_url}api/productos/get_img_unico_producto/${producto.id}/${producto.link_photo}`;

      const mensaje =
        `Hola , quiero consultar sobre este producto:

 *${producto.descripcion}*
 *Precio:* Gs. ${this.formatearPrecio(producto.pvu)}
 *Detalle:* ${producto.sub1}
 *Imagen:* ${imagenUrl}

¿Podrías darme más información, por favor?`;

      return `https://wa.me/${numero}?text=${encodeURIComponent(mensaje)}`;
    }
    ,

    formatearPrecio(valor) {
      if (!valor) return '0';
      return Math.floor(valor) // elimina decimales
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // agrega puntos como separador de miles
    },
    toggleExpand(id) {
      this.expandedId = this.expandedId === id ? null : id;
    },

    productoOpen(descripcion) {


      this.$router.push(`/producto/` + descripcion);


      //const url = this.$router.resolve({ path: `/producto/${descripcion}` }).href;
      //window.open(url, '_blank');


    },
    listarProductos(vendedorSeleccionadoLocal, reset = true) {
      this.loading = true;

      if (reset) {
        this.paginaActual = 1;
        this.productos = [];
      }

      vendedorService
        .listarProductoVendedorPublico(
          vendedorSeleccionadoLocal,
          this.categoriaSeleccionadaLocal,
          {
            page: this.paginaActual,
            per_page: this.productosPorPagina,
            buscar: this.buscador
          }
        )
        .then((resposta) => {

          console.log("lista obtenida a partir de vendedores en listarProductos");
          console.log(resposta.data);
          this.productos = reset
            ? resposta.data.data
            : this.productos.concat(resposta.data.data);

          if (resposta.data.meta) {
            this.paginaActual = resposta.data.meta.current_page;
            this.ultimaPagina = resposta.data.meta.last_page;
            this.totalProductos = resposta.data.meta.total;
          }
        }).finally(() => {
          this.loading = false;
        });

    },
    cargarMasProductos() {
      if (!this.hasMoreProductos || this.loading) {
        return;
      }

      this.paginaActual += 1;
      this.listarProductos(this.vendedorSeleccionadoLocal, false);
    },
    limpiar() {


      this.producto = {
        id: '',
        descripcion: '',
        sub1: '',
        link_photo: '',
        pvu: '',
        cantidad_total: '',
        observacion: '',
      }


    },
    copiarUrl(iden) {

      //let iden=localStorage.getItem("descripcion");

      const url = this.$router.resolve({ path: `/producto/${iden}` }).href;

      navigator.clipboard.writeText(window.location.origin + url)
        .then(() => {




          let mensajeText = 'URL copiada exitosamente';


          this.mensaje.text = mensajeText;

          this.mensaje.color = "primary";
          this.mensaje.colorBtn = "blue";

          this.mensaje.snackbar = "true";


        })
        .catch(err => {
          console.error('Error al copiar la URL:', err);
        });




    }


  },

  watch: { //VERIFICAR SI EN MENU PANTALLA STORE NO SE HACE LO

    vendedorSeleccionado(newVal) {

      console.log("LLamado al modif vendedorSeleccionado en Watch");



      this.vendedorSeleccionadoLocal = newVal;

       this.listarVendedores(this.vendedorSeleccionadoLocal);
      this.categoriaSeleccionadaLocal = 'todos';//Siempre es todos, por que se cargan todas las categorias por vendedor al inicio.
      this.listarProductos(newVal);


    },
    categoriaSeleccionada(newVal) {

      this.categoriaSeleccionadaLocal = newVal;
      this.listarProductos(this.vendedorSeleccionadoLocal);
      // this.categoriaSeleccionadaLocal='todos';


    },
    buscador() {
      this.listarProductos(this.vendedorSeleccionadoLocal);
    }


  },
  computed: {


    productosDescripcionBuscados() {
      return this.productos.filter(producto => {
        return producto.descripcion.toLowerCase().includes(this.buscador.toLowerCase());
      });

    },

    productosFiltrados() {
      let filtrados = this.productosDescripcionBuscados;

      if (this.categoriaSeleccionadaLocal !== "todos") {
        filtrados = filtrados.filter(
          (producto) =>
            producto.categoria &&
            producto.categoria.descripcion === this.categoriaSeleccionadaLocal
        );
      }

      // --- FILTRO POR VENDEDOR ---
      //if (this.vendedorSeleccionado != 0) {
      // filtrados = filtrados.filter(
      //  (producto) =>
      //     producto.vendedor &&
      //     producto.vendedor.id === this.vendedorSeleccionado
      // );
      //}

      // Ocultar stock 0
      // return filtrados.filter((producto) => parseFloat(producto.cantidad_total) > 0);
      return filtrados;
    },

    hasMoreProductos() {
      return this.paginaActual < this.ultimaPagina;
    },


  },
};
</script>
<style scoped>
h3 {
  font-weight: 600;
}

.product-grid {
  position: relative;
  min-height: 200px;
}

.loading-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255,255,255,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 8px;
}

/* SE NECESITA AGREGAR UN MARGEN PARA VISUALIZAR EL BANNER */
.v-carousel {
  margin-top: 270px;  

}


</style>
